import { useEffect, useState } from "react";
import { CustomSelectOptionType } from "../../../../explorer/components/FormFields/CustomSelect";
import ServiceProvider from "../../../configuration/ServiceProvider";
import useBrands from "../../../../explorer/hooks/useBrands";
import { reduxStoreConfig } from "../../../configuration/reduxStoreConfig";
import { useReduxState } from "../../../../explorer/redux/hooks";
import { Site } from "../../../../explorer/types/SpareParts";
import { DrawerSelect } from "../../../../explorer/components/FormFields/DrawerSelect";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Skeleton,
    Typography,
} from "@mui/material";
import useCurrentSite from "../../../hook/useCurrentSite";
import { useFormClasses } from "./CreateOfferOrderForm.style";
import { AppIconsArrow } from "../../AppIcons";

type ShipToAddressProps = {
    onSelectChange?: any;
    value?: any;
    readonly?: boolean;
};

export const ShipToAddress = (props: ShipToAddressProps) => {
    const [items, setItems] = useState<Site[]>([]);
    const [value, setValue] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);

    const { t } = useTranslation();
    const brand = useBrands().currentBrandUrl;
    const [currentSite, setCurrentSite] = useCurrentSite();

    const isReadonly = props.readonly ?? false;

    const classesForm = useFormClasses();

    useEffect(() => {
        if (props.value === undefined) {
            ServiceProvider.OrderOffer.getShipToAddress(brand)
                .then((result) => {
                    setItems(result);
                    setLoading(false);
                    if (result && result.length > 0) {
                        if (
                            result.some(
                                (s) =>
                                    s.customerSiteCode ===
                                    currentSite.customerSiteCode
                            )
                        ) {
                            setValue(currentSite.customerSiteCode ?? "");
                            props.onSelectChange(
                                null,
                                currentSite.customerSiteCode ?? ""
                            );
                        }
                    }
                })
                .catch((e) => console.error(e));
        } else {
            setLoading(false);
            const initialItems: Site[] = [
                {
                    customerSiteCode: props.value.shipToCode,
                    customerCode: props.value.shipToDto.customer,
                    address: props.value.shipToDto.address,
                    city: props.value.shipToDto.city,
                    zipCode: props.value.shipToDto.zipCode,
                    country: props.value.shipToDto.country,
                    customerSiteName: props.value.shipToDto.customerName,

                    // Add other fields as necessary
                },
            ];
            setItems(initialItems);
            setValue(props.value.shipToCode);
            props.onSelectChange(null, props.value.shipToCode);
        }
    }, []);

    const handleChange = (event: SelectChangeEvent) => {
        setValue(event.target.value.toString());
        if (props.onSelectChange)
            props.onSelectChange(event, event.target.value.toString());
    };

    return (
        <FormControl fullWidth>
            {loading ? (
                <Skeleton />
            ) : items.length > 0 ? (
                <>
                    <Typography sx={classesForm.title} id="shipToAddress">
                        {t("orderoffer.shipToAddress")}
                    </Typography>
                    <Select
                        labelId="input_label_ship_to_address"
                        id="input_select_ship_to_address"
                        label={t("orderoffer.shipToAddress")}
                        value={value}
                        onChange={handleChange}
                        variant="standard"
                        sx={classesForm.options}
                        disabled={props.readonly}
                        IconComponent={() => (
                            <AppIconsArrow
                                sx={{
                                    transform: "rotate(90deg)",
                                    fontSize: 15,
                                }}
                            />
                        )}
                    >
                        {items.map((site, idx: number) => (
                            <MenuItem
                                key={idx}
                                value={site.customerSiteCode}
                                sx={classesForm.options}
                            >
                                {site.customerSiteCode}-{site?.customerSiteName}{" "}
                                <br />
                                {site.address +
                                    " " +
                                    site.city +
                                    ", " +
                                    site.zipCode +
                                    " " +
                                    site.country}
                            </MenuItem>
                        ))}
                    </Select>
                </>
            ) : (
                <Box>{t("common.noitem")}</Box>
            )}
        </FormControl>
    );
};
